const orange50 = "#fff6e6";
const orange100 = "#ffe4b0";
const orange200 = "#ffd78a";
const orange300 = "#fec554";
const orange400 = "#feb933";
const orange500 = "#fea800";
const orange600 = "#e79900";
const orange700 = "#b47700";
const orange800 = "#8c5c00";
const orange900 = "#6b4700";
const oranges = {
  orange50,
  orange100,
  orange200,
  orange300,
  orange400,
  orange500,
  orange600,
  orange700,
  orange800,
  orange900
};
export {
  oranges as default,
  orange100,
  orange200,
  orange300,
  orange400,
  orange50,
  orange500,
  orange600,
  orange700,
  orange800,
  orange900
};
//# sourceMappingURL=index.es8.js.map
